import Modal from '../../ui/Modal/Modal';
import Button from '../../ui/Button/Button';
import Icon from '../../ui/Icon/Icon';
import { useAuth } from '../../../context/AuthContext';
import { useTheme } from '../../../context/ThemeContext';
import styles from './UserSettingsModal.module.css';

// Minimal user settings: profile (read-only, sourced from the OAuth provider)
// + appearance (theme picker, persisted in localStorage).
export default function UserSettingsModal({ isOpen, onClose }) {
  const { user } = useAuth();
  const { theme, setTheme, themes } = useTheme();
  if (!user) return null;

  const initial = (user.name || user.email || '?').charAt(0).toUpperCase();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="User settings"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      }
    >
      <div className={styles.profile}>
        {user.avatarUrl ? (
          <img src={user.avatarUrl} alt={user.name} className={styles.avatar} />
        ) : (
          <span className={styles.avatarFallback}>{initial}</span>
        )}
        <div className={styles.fields}>
          <Field label="Name" value={user.name || '—'} />
          <Field label="Email" value={user.email} />
          <Field label="Signed in with" value={user.provider} />
        </div>
      </div>
      <p className={styles.note}>
        Profile data comes from your identity provider and updates on next sign-in.
      </p>

      <div className={styles.sectionLabel}>appearance</div>
      <div className={styles.themeGrid}>
        {themes.map((t) => {
          const active = theme === t.id;
          return (
            <button
              key={t.id}
              type="button"
              className={`${styles.themeCard} ${active ? styles.themeCardActive : ''}`}
              onClick={() => setTheme(t.id)}
              aria-pressed={active}
            >
              <span
                className={styles.themeSwatch}
                data-theme-preview={t.id}
                aria-hidden="true"
              >
                <span className={styles.swatchA} />
                <span className={styles.swatchB} />
                <span className={styles.swatchC} />
              </span>
              <span className={styles.themeMeta}>
                <span className={styles.themeName}>{t.label}</span>
                <span className={styles.themeDesc}>{t.description}</span>
              </span>
              {active && (
                <span className={styles.themeActiveBadge}>
                  <Icon name="Check" size={10} />
                </span>
              )}
            </button>
          );
        })}
      </div>
    </Modal>
  );
}

function Field({ label, value }) {
  return (
    <div className={styles.field}>
      <span className={styles.fieldLabel}>{label}</span>
      <span className={styles.fieldValue}>{value}</span>
    </div>
  );
}
